import { postRequest } from "./QuoteApiService";

export async function getItemSLARates(id, body) {
    try {
        const res = await postRequest('GetItemSLARates/' + id, body);
        console.log("GetItemSLARates > axios res=", res);
        return res;
      } catch (error) {
        console.error("in services > GetItemSLARates, Err===", error);
        return error;
      }
}